import { getCompany } from "@/api/company/company-services"; // Importa la función
import LangSelect from "@/components/lang-select.jsx";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { siteConfig } from "@/config/site";
import { cn } from "@/lib/utils";
import { MenuIcon } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import {useStore} from "@/store/index.js";

const ClientHeader = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const companyData = useStore((state) => state.companyData);
    const renderNavLinks = (className) =>
    siteConfig.clientNav.map((item, index) => {
      if (
          item.titleKey === "ClientLayout.nav.consult" &&
          !companyData?.hasConsultation
      ) {
        return null;
      }
      const isActive = location.pathname === item.href;
      return (
        <NavLink
          key={index}
          to={item.href}
          className={cn(
            "transition-colors hover:text-primary",
            isActive && "text-primary",
            className,
          )}
        >
          {t(item.titleKey)}
        </NavLink>
      );
    });

  return (
    <header className="sticky w-full top-0 bg-white flex h-auto items-center justify-between gap-6 border-b px-6 md:px-10 2xl:px-16 p-[10px]">
      <div className="flex w-full justify-between max-w-7xl mx-auto">
        <NavLink to="/">
          <img
              src={companyData.logo || "/assets/logo.png"}
              alt="Company Logo"
              className="hidden md:flex h-auto max-w-[250px]"
          />
          <img
              src={companyData.logo || "/assets/mobile-logo.png"} // Usa el logo de la API o uno por defecto
              alt="Mobile Company Logo"
              className="flex md:hidden w-auto h-10 object-contain"
          />
        </NavLink>
        <nav className="hidden md:flex flex-row items-center gap-6 md:gap-8">
          {renderNavLinks()}
          <LangSelect/>
        </nav>
        <div className="md:hidden ml-auto flex items-center space-x-4">
          <Sheet>
            <SheetTrigger asChild={true}>
              <Button
                variant="outline"
                size="icon"
                className="!p-0 border-none"
              >
                <MenuIcon className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent>
              <div className="grid gap-6">
                {renderNavLinks()}
                <LangSelect />
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export { ClientHeader };
